<template>
  <div>
    <a href="mailto:stuff@studio308.co" id="contact-link" class="easy">say what</a>
  </div>
</template>

<script>
export default {
  name: 'contact-button',
  data () {
    return {
      msg: 'Studio 308 Contact'
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss

  #contact-link
    display: block
    width: 200px
    text-decoration: none
    text-align: center
    text-transform: uppercase
    line-height: 50px
    color: $mainColor
    border: 2px solid $mainColor
    margin: 50px auto

    &:hover
      color: $white
      background-color: $mainColor

    &:active
      background-color: $mainColorDark
      border: 2px solid $mainColorDark
  
</style>



// WEBPACK FOOTER //
// ContactButton.vue?35b6b146